/* eslint-disable no-param-reassign */

import { useState } from 'react';
import { Helmet } from 'react-helmet';
import {
  Box,
  Container,
  Button,
  Grid,
  Typography,
  Select,
  FormControl,
  MenuItem,
  InputLabel,
  TextField,
  Stack,
  Card,
  CardContent,
} from '@mui/material';
import {
  ArrowUpward,
} from '@mui/icons-material';
import { useDispatch, useSelector } from 'react-redux';
import LoanList from 'src/components/loans/LoanList';
// import { searchLoanByNumber } from '../store/orders/orders.action';
// import { isDateOverdue } from '../utils';

function DenisAdmin(...props) {
  const orderStatuses = ['Placed', 'Confirmed', 'In Transit', 'Delivered', 'Canceled'];
  const paymentMethods = ['Credit', 'Lipa Na Mpesa', 'Cash on delivery'];
  const paymentStatuses = ['Initiated', 'Paid', 'Canceled', 'Declined', 'Error', 'Submitted', 'Partially paid', 'Insufficient funds'];

  const [currentOrders, setCurrentOrders] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState('');
  const [selectedPayment, setSelectedPayment] = useState('');
  const [selectedLipaStatus, setSelectedLipaStatus] = useState('');
  const [isLipaDisabled, setLipaDisabled] = useState(true);

  const dispatch = useDispatch();
  const orderState = useSelector((state) => state.orderReducer);
  const { loans } = orderState;

  // const userState = useSelector((state) => state.userReducer);
  // const { distributors } = userState;

  // const today = new Date().toISOString().slice(0, 10);

  const handleStatusChange = (mStatus, mPayment, mLipaStatus) => {

  };

  const handlePaymentChange = (mStatus, mPayment, mLipaStatus) => {

  };

  const handleLipaStatus = (mStatus, mPayment, mLipaStatus) => {

  };

  // const handleApplyFilters = (status, payment, lipaStatus) => {

  // };

  // On search text
  const onSearchText = (text) => {
    // dispatch(searchLoanByNumber(text.target.value));
  };

  return (
    <>
      <Helmet>
        <title>Admin | Rewot dashboard</title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: 'background.default',
          minHeight: '100%',
          py: 3,
        }}
      >
        <Container maxWidth={false}>
          {/* <CustomerListToolbar /> */}

          <Grid container spacing={1}>

            <Grid item xs={9}>
              <Card>
                <CardContent>
                  <Typography variant="h6" sx={{ mb: 1 }}>FILTERS</Typography>

                  <Stack direction="row" spacing={3} sx={{ height: 56 }}>

                    <FormControl sx={{ minWidth: 200 }}>
                      <InputLabel id="order-status-label">Order Status</InputLabel>
                      <Select
                        labelId="order-status-label"
                        id="order-status-select"
                        value={selectedStatus}
                        onChange={(event) => handleStatusChange(event.target.value, selectedPayment, selectedLipaStatus)}
                        label="Order Status"
                      >
                        <MenuItem value="">
                          <em>All</em>
                        </MenuItem>

                        {orderStatuses.map((name) => (
                          <MenuItem
                            key={name}
                            value={name}
                          >
                            {name}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>

                    <FormControl sx={{ minWidth: 200 }}>
                      <InputLabel id="payment_method-label">Payment Method</InputLabel>
                      <Select
                        labelId="payment_method-label"
                        id="payment_method-select"
                        value={selectedPayment}
                        onChange={(event) => handlePaymentChange(selectedStatus, event.target.value, selectedLipaStatus)}
                        label="Payment method"
                      >
                        <MenuItem value="">
                          <em>All</em>
                        </MenuItem>

                        {paymentMethods.map((name) => (
                          <MenuItem
                            key={name}
                            value={name}
                          >
                            {name}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>

                    <FormControl sx={{ minWidth: 200 }} disabled={isLipaDisabled}>
                      <InputLabel id="lipa-status-label">Payment Status</InputLabel>
                      <Select
                        labelId="lipa-status-label"
                        id="lipa-status-select"
                        value={selectedLipaStatus}
                        onChange={(event) => handleLipaStatus(selectedStatus, selectedPayment, event.target.value)}
                        label="Mpesa Status"
                      >
                        <MenuItem value="">
                          <em>All</em>
                        </MenuItem>

                        {paymentStatuses.map((name) => (
                          <MenuItem
                            key={name}
                            value={name}
                          >
                            {name}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>

                    <FormControl sx={{ minWidth: 200 }}>
                      <TextField
                        id="outlined-basic"
                        label="Search"
                        variant="outlined"
                        onChange={onSearchText}
                      />
                    </FormControl>

                  </Stack>
                </CardContent>
              </Card>
            </Grid>

            <Grid item xs={3}>

              <Grid
                container
                spacing={1}
                direction="row"
                justifyContent="flex-end"
                sx={{ mt: 4 }}
              >

                <Stack direction="row" spacing={3} sx={{ height: 56 }}>
                  { currentOrders && (

                    <Button variant="contained" sx={{ marginRight: 0, color: 'white' }} startIcon={<ArrowUpward />}>
                      EXPORT
                    </Button>

                  )}
                </Stack>

              </Grid>
            </Grid>
          </Grid>

          <Box sx={{ pt: 3 }}>
            <LoanList loans={loans} title="Loans" paginate />
          </Box>
        </Container>
      </Box>
    </>
  );
}
export default DenisAdmin;
